import logger from '@/utils/logger'

/**
 * Nettoie un éventuel drapeau d'interaction MSAL resté bloqué.
 *
 * MSAL stocke un statut `interaction.status` (clé du type
 * `msal.<clientId>.interaction.status`) pendant une interaction
 * (login/logout par redirection). Si une interaction est interrompue
 * (logout non terminé, redirection bloquée, onglet fermé...), ce drapeau
 * persiste et fait échouer tout appel interactif suivant avec
 * `BrowserAuthError: interaction_in_progress`.
 *
 * À n'appeler que lorsqu'on est sûr qu'aucune interaction légitime n'est
 * en cours (ex: page de login avant un clic, ou récupération après erreur).
 *
 * @returns {boolean} true si au moins une clé bloquée a été supprimée
 */
export function clearStuckInteraction () {
  let cleared = false

  for (const storage of [window.localStorage, window.sessionStorage]) {
    try {
      const keys = Object.keys(storage)
      for (const key of keys) {
        if (key.includes('interaction.status')) {
          storage.removeItem(key)
          cleared = true
        }
      }
    } catch (error) {
      logger.error(error)
    }
  }

  if (cleared) {
    logger.warn('MSAL: drapeau interaction.status bloqué nettoyé')
  }

  return cleared
}
